import { Navigate, RouteObject } from "react-router";
import SelskabsblankettenApp from "@/features/selskabsblanketten/App";
import HomeView from "@/features/selskabsblanketten/pages/home/HomeView";
import {
  ROUTES,
  VIRKSOMHEDSBLANKET_LEGACY_PATH,
  VIRKSOMHEDSBLANKET_PATH,
} from "@/constants/routes";

export const selskabsblankettenRoutes: RouteObject[] = [
  {
    path: VIRKSOMHEDSBLANKET_PATH,
    id: ROUTES.selskabsblanketten.id,
    element: <SelskabsblankettenApp />,
    children: [{ index: true, element: <HomeView /> }],
  },
  {
    // Bevarer gamle bogmærker efter omdøbningen i ADV-295.
    path: VIRKSOMHEDSBLANKET_LEGACY_PATH,
    element: <Navigate to={VIRKSOMHEDSBLANKET_PATH} replace />,
  },
];
